import React, { useState } from "react";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import { exportTableToCSV } from "../../utils/exportTableData";

export default function DownloadDataButton({
  headers = [],
  data = [],
  onDownload,
  filename = "download-data",
  disabled = false,
  tooltipTitle,
  sx = {},
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const isDisabled = disabled || loading || (!onDownload && (!Array.isArray(data) || data.length === 0));

  const handleClick = async (e) => {
    e.stopPropagation();
    if (isDisabled) return;
    if (typeof onDownload === "function") {
      try {
        setLoading(true);
        const fetchedData = await onDownload();
        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          exportTableToCSV(filename, headers, fetchedData);
        }
      } catch (err) {
        console.error("Export download error:", err);
      } finally {
        setLoading(false);
      }
    } else {
      exportTableToCSV(filename, headers, data);
    }
  };

  const currentTooltip = tooltipTitle || t("Download");

  return (
    <Tooltip title={currentTooltip}>
      <span>
        <IconButton
          onClick={handleClick}
          disabled={isDisabled}
          sx={{
            width: "30px",
            height: "30px",
            minWidth: "30px",
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            borderRadius: "4px",
            padding: "4px",
            color: "#64748B",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#F8FAFC",
              borderColor: "#CBD5E1",
              color: "#334155",
            },
            "&.Mui-disabled": {
              backgroundColor: "#F3F4F6",
              borderColor: "#E5E7EB",
              color: "#9CA3AF",
            },
            ...sx,
          }}
          aria-label={t("Download")}
        >
          {loading ? (
            <CircularProgress size={16} sx={{ color: "#64748B" }} />
          ) : (
            <DownloadIcon sx={{ fontSize: "18px" }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}
